import LoadbarComponent from "slotworks/components/preloader/loadbar-component";
import PromptContent, { LoadType } from "slotworks/components/prompt/prompt-content";
import Layers from "slotworks/graphics/layers/layers";
import Loader from "slotworks/loader/loader";
import SettingsModel from "slotworks/model/settings/settings-model";
import Contract from "slotworks/utils/contract";
import Timer from "slotworks/utils/timer";
import { InfoCommand } from "../../commands/error/info-command";
import RevolverModel from "../../integration/revolver/model/revolver-model";
import CommsManager from "../../server/comms-manager";
import { AxiosRequestConfig } from "axios";
import Logger = require("js-logger");
import BackCommand from "slotworks/commands/betbar/back-command";

export default class PromptComponent {

    public static DEFAULT_TIME = 5000;

    private currentPrompt: PromptContent;
    private buttonData: any;
    private messageAdditionalData: any;

    public show(scenes: string[], contents: Map<string, any>, time: number = null, loadStage: number = null, toggleHandler?: (value: boolean) => void): Contract<void> {
        if (time === null) {
            time = PromptComponent.DEFAULT_TIME;
        }

        const prompt = new PromptContent(scenes, time);

        prompt.addText(contents);
        /* to perform MESSAGE_BOX behaviour */
        if (contents) {
            this.buttonData = contents.get("button");
            this.messageAdditionalData = contents.get("data");
        }
        if (this.buttonData !== undefined) {
            if (this.buttonData.length !== 0) {
                for (let i = 0; i < this.buttonData.length; i++) {
                    prompt.addButton(this.buttonData[i].label, this.buttonAction(this.buttonData[i]));
                }
            } else {                
                prompt.addContinueButton();
            }
        } else {        
            prompt.addContinueButton();
        }
        prompt.addToggle("show", toggleHandler);
        return this.showPrompt(prompt, loadStage);
    }

    public showPrompt(prompt: PromptContent, loadStage: number = null): Contract<void> {

        this.currentPrompt = prompt;

        return new Contract<void>((resolve) => {

            this.currentPrompt.show().then(() => {
                let raceStages = 1;

                const raceHandler = () => {
                    raceStages--;
                    if (raceStages === 0) {
                        this.currentPrompt.hide().then(() => resolve(null)).execute();
                    }
                };

                this.currentPrompt.enableContinueButton();

                if (loadStage) {
                    raceStages++;
                    if (this.currentPrompt.getLoadRaceType() === LoadType.DISABLE_BUTTON) {
                        this.currentPrompt.disableContinueButton();
                    } else if (this.currentPrompt.getLoadRaceType() === LoadType.HIDE_BUTTON) {
                        this.currentPrompt.hideContinueButton();
                    }

                    this.loadStage(loadStage).then(() => {
                        this.currentPrompt.enableContinueButton();
                        raceHandler();
                    });
                }

                const onKeyUp = (event: any) => {             
                    if (SettingsModel.getSpaceToSpin()) {
                        if (event.keyCode === 32) {
                            onContinue();
                        }
                    }
                };

                const onContinue = () => {
                    document.removeEventListener("keyup", onKeyUp);

                    if (this.currentPrompt.getLoadRaceType() === LoadType.LOADING_SCENE && Layers.Prompts.hasScene("loading")) {
                        Layers.Prompts.setScene("loading").then(() => raceHandler());
                    } else {
                        raceHandler();
                    }
                };
                if (this.currentPrompt.hasContinueButton() || this.buttonData !== undefined) {
                    document.addEventListener("keyup", onKeyUp);
                    this.currentPrompt.addContinueListener(() => {
                        onContinue();
                    });
                } else {

                    Timer.setTimeout(() => {
                        onContinue();
                    }, this.currentPrompt.timeOutTime);
                }
            });
        });
    }

    public hide() {
        this.currentPrompt.hide().execute();
    }

    private loadStage(stageId: number): Contract<void> {

        const bar = Layers.Prompts.getSprite("loadbar");

        const loadBar = new LoadbarComponent(bar, Loader.getStageFiles(stageId));

        let loadSprite: PIXI.DisplayObject = Layers.Prompts.getSprite("loading_sprite");
        if (!loadSprite) {
            const loadButton = Layers.Prompts.getButton("loading_sprite");
            if (loadButton) {
                loadSprite = loadButton.container;
            }
        }

        loadBar.addLoadingText(Layers.Prompts.getText("loading_label"), Layers.Prompts.getText("loading_percentage"), loadSprite);

        return new Contract<void>((resolve) => {
            Loader.loadStage(stageId, (stage: number, progress: number, resource: PIXI.LoaderResource) => {
                loadBar.fileLoaded(resource);
            }).then(() => loadBar.loadComplete().then(() => resolve(null)));
        });
    }

    private buttonAction(buttonInfo: any) {
        let value: any;
        if (buttonInfo.link) {
            return value = () => {
                window.open(buttonInfo.link);
            };
        } else if (buttonInfo.action === "close") {
            return value = () => {
                window.close();
            };
        } else if (buttonInfo.action === "back") {
            return value = () => {
                BackCommand();
            };
        } else if (buttonInfo.action === "refresh") {
            return value = () => {
                window.location.reload();
            };
        } else if (buttonInfo.action === "show_secondary_message") {
            return value = () => {
                // Here We Should update Contents Of the Message And Show Secondary Message
                if (this.messageAdditionalData) {
                    if (this.messageAdditionalData.secondaryMessage) {
                        // Close This Current Message And Shoe New One
                        // return InfoCommand();
                        this.hide();
                        // Show New Message
                        InfoCommand(this.messageAdditionalData.secondaryMessage.text, ["message"], this.messageAdditionalData.secondaryMessage.buttons).execute();
                        Layers.BetBar.show();
                        Layers.SmartButton.show();

                    }
                }

            };
        } else if (buttonInfo.action === "continue") {
            return value = () => {
                this.hide();
                Layers.BetBar.show();
                Layers.SmartButton.show();
            };
        } else if (buttonInfo.action === "reality_reset") {
            return value = () => {
                const realityResetRequest = {
                    method: "post",
                    url: RevolverModel.getBaseURL(),
                    withCredentials: true,
                    data: JSON.stringify({
                        cmd: "CUSTOM",
                        action: "reality",
                        payload: {
                            decision: "reset"
                        }
                    })
                } as AxiosRequestConfig;
                CommsManager.requestRaw(realityResetRequest).then(() => {
                    this.hide();
                    Layers.BetBar.show();
                    Layers.SmartButton.show();
                });
            };
        } else if (buttonInfo.action === "history") {
            return value = () => {
                window.open(SettingsModel.historyURL + RevolverModel.session + "?lang=" + SettingsModel.language);
            };
        } else if (buttonInfo.action === "reality_stop") {
            return value = () => {
                const realityResetRequest = {
                    method: "post",
                    url: RevolverModel.getBaseURL(),
                    withCredentials: true,
                    data: JSON.stringify({
                        cmd: "CUSTOM",
                        action: "reality",
                        payload: {
                            decision: "stopgaming"
                        }
                    })
                } as AxiosRequestConfig;
                CommsManager.requestRaw(realityResetRequest).then(() => {
                    if (SettingsModel.homeURL === "close" || SettingsModel.homeURL === "" || SettingsModel.homeURL === undefined || SettingsModel.homeURL === null) {
                        window.close();
                    } else if (SettingsModel.homeURL === "back") {
                        BackCommand();
                    } else {
                        window.open(SettingsModel.homeURL, "_self");
                    }
                });
            };
        }
    }
}




// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/components/prompt/prompt-component.ts